<template>
  <div id="app">
    
    <router-view />

  </div>
</template>

<script>
//import Navigation from "@/components/Navigation.vue";

import { mapGetters, mapActions } from "vuex";

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);

export default {
  name: 'App',
  components: {
    //navigation: Navigation
  },
  computed: {
    ...mapGetters(["getUser", "isUserAuth"])
  },
  methods: {
    ...mapActions(["authAction"])
  },
  created() {
    this.authAction();
  }
};

</script>

<style lang="scss">
// 1. Your custom variables and variable overwrites.

// 2. Import default variables and available mixins.
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/mixins.scss";

// 3. Your custom mixin overwrites.
@mixin hook-card() { color: #000; }

// 4. Import UIkit.
@import "../node_modules/uikit/src/scss/uikit-theme.scss";

@import "@/assets/scss/style.scss";
</style>
